import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CaiDatGiaTriControl = _resolveComponent("CaiDatGiaTriControl")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_FormModalShell = _resolveComponent("FormModalShell")!

  return (_openBlock(), _createBlock(_component_FormModalShell, {
    "is-display": _ctx.isOpen,
    title: "Thêm khóa cài đặt",
    size: "lg",
    width: "560px",
    onClose: _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.CANCEL,
        "color-type": _ctx.ButtonTypeColors.SECONDARY,
        "is-disabled": _ctx.saving,
        onClick: _ctx.onClose
      }, {
        "button-label": _withCtx(() => [
          _createTextVNode("Huỷ")
        ]),
        _: 1
      }, 8, ["button-type", "color-type", "is-disabled", "onClick"]),
      _createVNode(_component_ButtonCustom, {
        "button-type": _ctx.ButtonsType.SAVE,
        "color-type": _ctx.ButtonTypeColors.SUCCESS,
        "is-loading": _ctx.saving,
        "is-disabled": _ctx.saving,
        onClick: _ctx.submit
      }, {
        "button-label": _withCtx(() => [
          _createTextVNode("Tạo mới")
        ]),
        _: 1
      }, 8, ["button-type", "color-type", "is-loading", "is-disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Khóa",
            prop: "khoa"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.khoa,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.khoa) = $event)),
                placeholder: "VD: OPT_FOO"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Kiểu giá trị",
            prop: "loai_gia_tri"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.loai_gia_tri,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.loai_gia_tri) = $event)),
                class: "w-full",
                onChange: _ctx.onLoaiChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loaiGiaTriOptions, (option) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: option.value,
                      label: option.label,
                      value: option.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          (_ctx.form.loai_gia_tri === 'dropdown')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "Tuỳ chọn",
                prop: "tuy_chon"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.tuy_chon, (opt, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "d-flex align-items-center gap-2 mb-2"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: opt.value,
                          "onUpdate:modelValue": ($event: any) => ((opt.value) = $event),
                          placeholder: "Value",
                          style: {"width":"40%"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_el_input, {
                          modelValue: opt.label,
                          "onUpdate:modelValue": ($event: any) => ((opt.label) = $event),
                          placeholder: "Label",
                          style: {"flex":"1"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          link: "",
                          disabled: _ctx.form.tuy_chon.length <= 1,
                          onClick: ($event: any) => (_ctx.removeTuyChon(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Xoá ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])
                      ]))
                    }), 128)),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _ctx.addTuyChon
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Thêm tuỳ chọn")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "Giá trị mặc định",
            prop: "gia_tri"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CaiDatGiaTriControl, {
                modelValue: _ctx.form.gia_tri,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.gia_tri) = $event)),
                "loai-gia-tri": _ctx.form.loai_gia_tri,
                "tuy-chon": _ctx.form.tuy_chon,
                placeholder: "Giá trị seed cho mọi đơn vị"
              }, null, 8, ["modelValue", "loai-gia-tri", "tuy-chon"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Ghi chú",
            prop: "ghi_chu"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.ghi_chu,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.ghi_chu) = $event)),
                type: "textarea",
                rows: 2,
                placeholder: "Mô tả (tuỳ chọn)"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["is-display", "onClose"]))
}